<h2 mat-dialog-title i18n>Sample Analysis</h2>
<mat-dialog-content>
  <form>
    <div>
      <app-input i18n [formCntlName]="analysisNameControl" [inputType]="'text'" [label]="'Analysis Name'"></app-input>
      <mat-error class="error" i18n *ngIf="analysisNameControl.hasError('required') && analysisNameControl.touched"
        >Please enter an analysis name.
      </mat-error>
      <mat-error class="error" i18n *ngIf="analysisNameControl.hasError('whitespace') && analysisNameControl.touched"
        >Input cannot be just spaces.
      </mat-error>
      <app-input
        i18n
        [formCntlName]="analysisDescControl"
        [inputType]="'text'"
        [label]="'Analysis Description'"
      ></app-input>
      <mat-error class="error" i18n *ngIf="analysisDescControl.hasError('whitespace') && analysisDescControl.touched"
        >Input cannot be just spaces.
      </mat-error>
    </div>
    <!-- Paste this block after the Panel dropdown div -->
    <div>
      <mat-label class="input-label" i18n>Application</mat-label>
      <app-dropdown
        [label]="'Select Application'"
        [options]="applicationDropdownOptions"
        [formControlObj]="applicationControl"
        (selectedValueChange)="onApplicationChange($event)"
      ></app-dropdown>
    </div>
    <div>
      <mat-label class="input-label" i18n>Application Config</mat-label>
      <app-dropdown
        [label]="'Select Application Config'"
        [options]="panelDropdownOptions"
        [formControlObj]="panelControl"
      ></app-dropdown>
    </div>
    <mat-error *ngIf="isErrorVisible" i18n>{{ errorMessage }}</mat-error>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <app-buttons
    [isDisabled]="false"
    [name]="cancelBtnLabel"
    [buttonType]="'mat-button'"
    [buttonStyle]="'btn-text'"
    (buttonClickEvent)="closePopup()"
  >
  </app-buttons>

  <app-buttons
    [isDisabled]="
      !analysisNameControl.valid ||
      !analysisDescControl.valid ||
      !applicationControl.valid ||
      !panelControl.valid ||
      isSubmitting
    "
    [name]="doneBtnLabel"
    [buttonType]="'mat-flat-button'"
    [buttonStyle]="
      !analysisNameControl.valid ||
      !analysisDescControl.valid ||
      !applicationControl.valid ||
      !panelControl.valid ||
      isSubmitting
        ? btnStyleFilledSmallForPrimaryBtnDisabled
        : 'btn-filled-small'
    "
    (buttonClickEvent)="onSubmit()"
  >
  </app-buttons>
</mat-dialog-actions>
